<template>
  <div class="page-container">
    <md-app md-mode="reveal">
      <md-app-toolbar class="md-primary">
        <Header :menuVisible="menuVisible" v-on:toggleMenu="toggleMenu"/>
      </md-app-toolbar>

      <md-app-drawer :md-active.sync="menuVisible">
        <Menu :menuVisible="menuVisible"/>
      </md-app-drawer>

      <md-app-content>
        <md-content style="margin-left: 18px; margin-right: 18px;">
            <gmap-map
                :center="center"
                :zoom="12"
                map-type-id="terrain"
                style="width: 100%; height: 400px;">
                <gmap-marker
                    :key="index"
                    v-for="(m, index) in markers"
                    :position="m.position"
                    :clickable="true"
                    :draggable="false"
                    @click="center=m.position">
                </gmap-marker>
            </gmap-map>
        </md-content><br />

        <md-table v-model="markers" md-card md-fixed-header>
            <md-table-toolbar>
                <div>
                    <h1 class="md-title">Eventos</h1>
                </div>
            </md-table-toolbar>

            <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell md-label="Fecha">{{ item.date | formatTimestamp }}</md-table-cell>
                <md-table-cell md-label="Evento">{{ eventName(item.label) }}</md-table-cell>
                <md-table-cell md-label="Ubicación">
                    <a v-bind:href="''+eventLink(item.position)+''" target="_blank">
                        {{ eventLocation(item.position) }}
                    </a>
                </md-table-cell>
            </md-table-row>
        </md-table>
      </md-app-content>
    </md-app>
  </div>
</template>

<style lang="scss" scoped>
  .md-app {
    border: 1px solid rgba(#000, .12);
  }
</style>

<script>
import Vue from 'vue'
import Header from './Header.vue';
import Menu from './Menu.vue';
import firebase from 'firebase';
import {config} from '../helpers/apiConfig'
import {user} from '../helpers/user'

import * as VueGoogleMaps from 'vue2-google-maps'
Vue.use(VueGoogleMaps, {
  load: {
    key: config.googleMapKey
  }
});

var markers = [];

export default {
    name: 'MAP',
    components: {
        Header, Menu
    },
    data () {
      return {
        menuVisible: false,
        center: {lat:-34.4236322, lng:-58.6935206},
        markers: markers
      }
    },
    watch: {
        '$route': 'fetchData'
    },
    mounted() {
        firebase.auth().onAuthStateChanged((liuser) => {
        if (liuser) {
            console.log('User logged in, go ahead...');
            var that = this;
            user.init(firebase.auth().currentUser, () => {
                that.fetchData();
            });
        } else {
            this.$router.push('/auth')
            console.log('User not logged in!');
        }
        });
    },
    methods: {
        toggleMenu: function () {
            this.menuVisible = !this.menuVisible
        },
        fetchData () {
            console.log("in fetchData");
            var eventsRef = firebase.database().ref(config.rtDatabasePrefix + '/events');
            eventsRef.limitToLast(50).on("child_added", function(snapshot, prevChildKey) {
                var newEvent = snapshot.val();
                console.log("newEvent: ", newEvent);
                
                markers.unshift({
                    date: (newEvent.createdAt/1000),
                    label: newEvent.event,
                    position: {
                        lat: newEvent.lat,
                        lng: newEvent.lng
                    }
                });

                if (markers.length > 50) {
                    markers.pop();
                }
            });
        },
        eventName (label) {
            var n = {
                'APP_OPEN': 'Inicio de Aplicación',
                'LOGIN_AUTO_OK': 'Ingreso de jugador automático (OK)',
                'LOGIN_AUTO_ERROR': 'Ingreso de jugador automático (ERROR)',
                'LOGIN_MANUAL_OK': 'Ingreso de jugador manual (OK)',
                'LOGIN_MANUAL_ERROR': 'Ingreso de jugador manual (ERROR)',
                'LOGIN_GOOGLE_OK': 'Ingreso de jugador con datos de Google (OK)',
                'LOGIN_GOOGLE_ERROR': 'Ingreso de jugador con datos de Google (ERROR)',
                'LOGIN_GOOGLE_NOEMAIL': 'Ingreso de jugador con datos de Google (Email no verificado)',
                'LOGIN_GOOGLE_PLAYER_CREATE_OK': 'Registro de usuario con datos de Google (OK)',
                'LOGIN_GOOGLE_PLAYER_CREATE_ERROR': 'Registro de usuario con datos de Google (ERROR)',
                'LOGIN_FB_OK': 'Ingreso de jugador con datos de Facebook (OK)',
                'LOGIN_FB_ERROR': 'Ingreso de jugador con datos de Facebook (ERROR)',
                'LOGIN_FB_NOEMAIL': 'Ingreso de jugador con datos de Facebook (Email no verificado)',
                'LOGIN_FB_PLAYER_CREATE_OK': 'Registro de usuario con datos de Facebook (OK)',
                'LOGIN_FB_PLAYER_CREATE_ERROR': 'Registro de usuario con datos de Facebook (ERROR)',
                'LOGIN_VERIFICATION_SENT_OK': 'Envío de email de verificación (OK)',
                'LOGIN_VERIFICATION_SENT_ERROR': 'Envío de email de verificación (ERROROK)',
                'LOGOUT_OK': 'Desconexión (OK)',
                'CHANGEPASS_OK': 'Cambio de clave (OK)',
                'CHANGEPASS_ERROR': 'Cambio de clave (ERROR)',
                'RESETPASS_OK': 'Regeneración de clave (OK)',
                'RESETPASS_ERROR': 'Regeneración de clave (ERROR)',
                'REGISTER_OK': 'Registro de usuario (OK)',
                'REGISTER_ERROR': 'Registro de usuario (ERROR)',
                'GAME_START': 'Inicio de juego',
                'ANSWER_OK': 'Respuesta CORRECTA',
                'ANSWER_ERROR': 'Respuesta INCORRECTA',
                'GAME_END': 'Final de juego'
            };
            return (n[label]) ? n[label] : label;
        },
        eventLocation (position) {
            return position.lat + ', ' + position.lng;
        },
        eventLink (position) {
            return 'https://www.google.com/maps/search/?api=1&query=' + position.lat + ', ' + position.lng
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Map.vue